"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalBarChart = void 0;
const react_1 = __importDefault(require("react"));
const shape_1 = require("@visx/shape");
const group_1 = require("@visx/group");
const scale_1 = require("@visx/scale");
const axis_1 = require("@visx/axis");
const styled_components_1 = require("styled-components");
const polished_1 = require("polished");
const variants_1 = require("../../themes/variants");
const main_1 = require("../useTooltip/main");
const defaultMargin = { top: 10, right: 10, bottom: 10, left: 40 };
function VerticalBarChart({ width, height, showXTicks, margin = defaultMargin, onChange, yLabel, numTicks = 6, tooltip = true, data, variant, selectedLabel, }) {
    const theme = (0, styled_components_1.useTheme)();
    const chartTooltip = (0, main_1.useTooltip)();
    const greyColor = (0, polished_1.lighten)(0.2, theme.textColor);
    const primaryColor = (0, variants_1.variantTextColor)({ theme, variant });
    const { bgColor } = theme;
    if (data === undefined || data.length === 0 || width < 10) {
        return null;
    }
    const headingWidth = margin.left * 1.5;
    const yMax = height - margin.bottom;
    const labels = data.map((d) => d.label);
    const values = data.map((d) => d.value);
    const xScale = (0, scale_1.scaleBand)({
        range: [margin.left + headingWidth, width - margin.right],
        round: true,
        domain: labels,
        padding: 0.2,
    });
    const xValueMax = Math.max(...values, 0);
    const xValueMin = Math.min(...values, 0);
    const yScale = (0, scale_1.scaleLinear)({
        range: [margin.top, height - margin.bottom],
        domain: [xValueMax, xValueMin],
        round: true,
    });
    function getTooltipData(data, renderer = tooltip) {
        let tooltipLeft = xScale(data.label) || 0;
        let tooltipTop = yScale(data.value);
        tooltipLeft = tooltipLeft && tooltipLeft + xScale.bandwidth() / 2;
        return {
            top: tooltipTop + 15,
            left: tooltipLeft + 15,
            title: yLabel,
            values: [{ label: data.label, value: data.value, color: data.color }],
            renderer,
        };
    }
    const containerSize = {
        width,
        height,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("svg", Object.assign({}, containerSize),
            react_1.default.createElement("rect", Object.assign({}, containerSize, { rx: 14, fill: bgColor })),
            react_1.default.createElement(axis_1.AxisLeft, { scale: yScale, stroke: greyColor, tickStroke: greyColor, left: margin.left + headingWidth, numTicks: numTicks, tickLabelProps: (e) => {
                    return {
                        x: -15,
                        fill: greyColor,
                        fontSize: 11,
                        textAnchor: "end",
                    };
                }, label: yLabel, labelProps: {
                    y: -headingWidth,
                    textAnchor: "middle",
                    fontSize: 15,
                    fontWeight: 800,
                    fill: greyColor,
                } }),
            react_1.default.createElement(axis_1.AxisTop, { left: 0, top: yScale(0), scale: xScale, stroke: greyColor, tickStroke: greyColor, tickLabelProps: () => ({
                    fill: showXTicks ? greyColor : "transparent",
                    fontSize: 11,
                    textAnchor: "middle",
                }), hideTicks: true }),
            react_1.default.createElement(group_1.Group, null, data.map((d) => {
                const yLab = d.label;
                const barX = xScale(yLab) || 0;
                const barWidth = xScale.bandwidth();
                let barHeight = yScale(0) - yScale(d.value);
                let barY = yScale(0) - (d.value < 0 ? 0 : barHeight);
                let fillColor = d.color || primaryColor;
                if (yLab === selectedLabel) {
                    fillColor = (0, polished_1.darken)(0.2, fillColor);
                }
                return (react_1.default.createElement(shape_1.Bar, { key: `bar-${yLab}`, x: barX, y: barY, width: barWidth, height: Math.abs(barHeight), fill: fillColor }));
            })),
            react_1.default.createElement(group_1.Group, null, data.map((d) => {
                const yLab = d.label;
                const barX = xScale(yLab);
                const barY = 0;
                const barHeight = height;
                const barWidth = xScale.bandwidth();
                const size = {
                    x: barX,
                    y: barY,
                    width: barWidth,
                    height: barHeight,
                };
                return (react_1.default.createElement(shape_1.Bar, Object.assign({ key: `bar-${yLab}` }, size, { fill: "transparent", cursor: "pointer", onClick: onChange &&
                        function handleOnChange() {
                            onChange(d);
                        }, onMouseLeave: () => {
                        tooltip && chartTooltip.hide();
                    }, onMouseMove: (e) => {
                        tooltip && chartTooltip.show(getTooltipData(d));
                    } })));
            })),
            chartTooltip.data && (react_1.default.createElement("g", null,
                react_1.default.createElement(shape_1.Line, { from: {
                        y: margin.top,
                        x: chartTooltip.data.left - 15,
                    }, to: { y: yMax, x: chartTooltip.data.left - 15 }, stroke: primaryColor, strokeWidth: 1, pointerEvents: "none", strokeDasharray: "5,2" }),
                react_1.default.createElement("circle", { cy: chartTooltip.data.top - 15, cx: chartTooltip.data.left - 15, r: 4, fill: primaryColor, stroke: "white", strokeWidth: 2, pointerEvents: "none" })))),
        chartTooltip.element));
}
exports.VerticalBarChart = VerticalBarChart;
//# sourceMappingURL=main.js.map